/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormsApi } from '../api/forms.api';
import { FormResp, SondageForm, SondageFormData } from '../../../interfaces/common/forms';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { map } from 'rxjs/operators';

@Injectable()
export class FormsService extends SondageFormData {

  constructor(private api: FormsApi) {
    super();
  }

  get gridDataSource(): DataSource {
    return this.api.formsDataSource;
  }

  getAll(): Observable<SondageForm[]> {
    return this.api.getAll();
  }

  list(pageNumber: number = 1, pageSize: number = 10): Observable<SondageForm[]> {
    return this.api.list(pageNumber, pageSize);
  }


  get(id: number): Observable<SondageForm> {
    return this.api.get(id);
  }

  getPublic(id: number): Observable<SondageForm> {
    return this.api.getPublic(id);
  }

  create(form: any): Observable<SondageForm> {
    const formData = {
      name: form.name,
      desc: form.desc,
      config: JSON.stringify(form.config),
      experation: form.experation,
      ispublic: form.ispublic
    }
    return this.api.add(formData);
  }

  update(form: any): Observable<SondageForm> {
    return this.api.update(form);
  }

  delete(id: number): Observable<boolean> {
    return this.api.delete(id);
  }

  saveResp(formResp: FormResp): Observable<FormResp> {
    const respData = {
      formId: formResp.formId,
      response: formResp.response,
      time: formResp.time,
    };
  
    return this.api.addResp(respData);
  }
  getAllResp(id: number): Observable<FormResp[]> {
    return this.api.getAllResp(id);
  }
}
